<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :modal="false"
    custom-class="custom-dialog"
    :width="dialogType === '个人信息完善' ? '80vw' : ''"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div
      slot="title"
      class="title"
    >
      <div class="title-name">{{ dialogType }}</div>
      <div class="side-title"></div>
      <div class="handle-btn">
        <!-- <i class="el-icon-s-tools" slot="reference" style="cursor:pointer"></i> -->
      </div>
    </div>
    <div v-if="dialogType === '小程序二维码'">
      <div
        class="mp-code"
        v-if="MpCode"
      ><img
          :src="MpCode"
          alt
        /></div>
    </div>
    <div v-else-if="dialogType === '用户绑定' || dialogType === '个人信息完善'">
      <div class="bind-main">
        <!-- <div class="bind-fixed">
          <p><b>绑定流程</b></p>
          <p style="font-size:14px;margin-bottom:20px">
            1.核心系统与工作微信绑定 <br />
            2.关注公众号“圆手查薪酬” <br />
            3.完善个人信息
          </p>
        </div> -->
        <div class="bind-step">
          <div v-if="bindStep == 1">
            <p><b>第一步</b></p>
            <p>
              1.使用<b>工作微信</b>扫描下方二维码 <br />
              2.输入核心系统的用户名及密码，点击“确定” <br />
              3.提示“绑定成功”后关闭手机端网页
            </p>
            <div v-if="QRcode"><img
                :src="QRcode"
                alt=""
              /></div>
          </div>
          <div v-if="bindStep == 2">
            <p><b>第二步</b></p>
            <p>使用<b>工作微信</b>扫描下方二维码，关注公众号“圆手查薪酬”，发布职位可立即获得推送，方便转发</p>
            <div><img
                src="./public-code.jpg"
                alt=""
              /></div>
          </div>
          <el-dialog
            :visible.sync='bindVisible'
            :append-to-body='true'
            width="40vw"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :modal="false"
            @close='toEditInfo'
            custom-class="custom-dialog green-bg"
          >
            <div class="green-bg">
              <div class="bind-title">
                猎头微名片已绑定成功
              </div>
              <div class="bind-tips">
                <div>你将获得：</div>
                <div>
                  1、专属于你的猎头主页；
                  <br>
                  2、随时可分享运作中的职位给候选人；
                  <br>
                  3、候选人实时跟踪，职位反馈状态提醒；
                </div>
              </div>
              <div class="bind-side-title">2分钟打造自己的猎头微名片，让候选人主动来找你</div>
              <el-button
                class="bind-button"
                size="large"
                @click="toEditInfo"
              >打造我的猎头主页</el-button>
              <div class="bind-pic">
                <img
                  src="./exampleCard.png"
                  alt=""
                >
              </div>
            </div>
          </el-dialog>
          <div
            v-if="bindStep == 3"
            class="bind-input"
          >
            <div class="left-part">
              <div class="part-title">基本信息：</div>
              <div class="input-item">
                <div class="input-label"><b>*</b>姓名：</div>
                <div class="input-wrap">
                  <el-input
                    size="small"
                    v-model="name"
                  ></el-input>
                </div>
                <div class="input-tips">此为对外展示姓名，默认来自系统，可自行修改</div>
              </div>
              <div class="input-item">
                <div class="input-label"><b>*</b>头像：</div>
                <div class="input-wrap">
                  <span>使用个人照片</span>
                  <el-radio
                    v-model="ifSelfPhoto"
                    @change='ifSelfPhotoChange'
                    :label="true"
                  >是</el-radio>
                  <el-radio
                    v-model="ifSelfPhoto"
                    @change='ifSelfPhotoChange'
                    :label="false"
                  >否</el-radio>
                  <el-select
                    v-model="avatar"
                    placeholder="请选择"
                    v-if="!ifSelfPhoto"
                  >
                    <el-option
                      v-for="(item,idx) in defaultAvatars"
                      :key="idx"
                      :label="'背景'+(idx+1)"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="input-tips">此为对外展示头像</div>
              </div>
              <div class="input-item">
                <div class="input-label"><b>*</b>地域：</div>
                <div class="input-wrap">
                  <el-input
                    size="small"
                    v-model="address"
                  ></el-input>
                </div>
                <div class="input-tips">此为您的所在地，默认来自系统，可自行修改</div>
              </div>
              <div class="part-title">自我介绍：<span>（展现个人优势，让候选人更了解和信任你~）</span></div>
              <div class="input-item">
                <div class="input-label"><b>*</b>擅长领域：</div>
                <div class="input-wrap muti-input">
                  <el-input
                    size="small"
                    v-model="goodat[0]"
                  ></el-input>
                  <el-input
                    size="small"
                    v-model="goodat[1]"
                  ></el-input>
                  <el-input
                    size="small"
                    v-model="goodat[2]"
                  ></el-input>
                </div>
                <div class="input-tips">此为您的擅长领域，最多可写三项。默认来自系统，可自行修改</div>
              </div>
              <div
                class="input-item-textarea"
                style="margin-bottom:15px"
              >
                <div
                  class="input-label"
                  style="margin-bottom:15px"
                ><b>*</b>个人介绍：<span
                    @click="openExample('个人介绍')"
                    style="margin-left:15px;color:#409EFF;font-size:12px;cursor:pointer"
                  ><i
                      class="el-icon-view"
                      style="margin-right:10px"
                    ></i>看看别人怎么写</span></div>
                <div
                  class="input-wrap"
                  style="padding-left:90px"
                >
                  <el-input
                    size="small"
                    type="textarea"
                    :autosize="{ minRows: 4, maxRows: 6}"
                    v-model="desc"
                    placeholder="可填写关于您或者公司的介绍。例如：专注于投行、DCM领域的猎头"
                  ></el-input>
                </div>
                <div class="input-tips">默认来自系统，可自行修改</div>
              </div>
              <div class="input-item">
                <div
                  class="input-label"
                  style="width:100%;margin-bottom:15px"
                >个人优势：<span
                    style="display:block;margin-left:15px;color:#409EFF;font-size:12px;cursor:pointer"
                    @click="openExample('个人优势')"
                  ><i
                      class="el-icon-view"
                      style="margin-right:10px"
                    ></i>看看别人怎么写</span></div>
                <div
                  class="input-wrap muti-input"
                  style="padding-left:90px"
                >
                  <el-input
                    size="small"
                    v-model="advantage[0]"
                  ></el-input>
                  <el-input
                    size="small"
                    v-model="advantage[1]"
                  ></el-input>
                  <el-input
                    size="small"
                    v-model="advantage[2]"
                  ></el-input>
                </div>
                <div class="input-tips">此为您的个人优势，最多可写三项。默认来自系统，可自行修改</div>
              </div>
              <div class="part-title">联系方式：<span>（候选人联系您的途径）</span></div>
              <div class="input-item">
                <div class="input-label"><b>*</b>手机：</div>
                <div class="input-wrap">
                  <el-input
                    size="small"
                    v-model="tel"
                  ></el-input>
                  <el-checkbox
                    v-model="phoneIsWechat"
                    style="margin-left:10px"
                  >手机等于微信</el-checkbox>
                </div>
                <div class="input-tips">填写您的常用手机号</div>
              </div>
              <div class="input-item">
                <div class="input-label">微信：</div>
                <div class="input-wrap">
                  <el-input
                    size="small"
                    v-model="weixin"
                  ></el-input>
                </div>
                <div class="input-tips">填写您的微信号</div>
              </div>
            </div>
            <div class="right-part">
              <div class="part-title">预览</div>
              <div style="background-color: #f6f6f6; padding-bottom: 100px">
                <div class="hunter">
                  <img
                    :src="avatar"
                    alt=""
                  />

                  <div class="hunter-info-box">
                    <div class="hunter-info">
                      <div class="hunter-info-name">{{ name }}</div>
                      <div class="hunter-info-location">{{ address }}<span
                          v-for="(item,idx) in goodat"
                          :key="idx"
                        >{{item?'｜':''}}{{item}}</span>
                      </div>
                      <div class="hunter-info-desc">{{ desc }}</div>
                    </div>
                    <div
                      class="hunter-info-num"
                      v-if="hunterId!=='system'"
                    >
                      <div class="hunter-info-num-item">
                        <img
                          src="./icon1.png"
                          alt=""
                        />
                        {{advantage[0]}}
                      </div>
                      <div class="hunter-info-num-item">
                        <img
                          src="./icon2.png"
                          alt=""
                        />
                        {{advantage[1]}}
                      </div>
                      <div class="hunter-info-num-item">
                        <img
                          src="./icon3.png"
                          alt=""
                        />
                        {{advantage[2]}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="job-list">
                  <div class="title">运作职位</div>
                  <div
                    class="job-item"
                    @click="toJobDetail(item)"
                    v-for="(item, idx) in jobs"
                    :key="idx"
                  >
                    <div class="job-row jcsb">
                      <div class="job-title">{{ item['标题'] }}</div>
                      <div
                        class="job-side-text dark-text"
                        style="color: #ceab76; font-weight: 600; font-size: 13px"
                      >
                        <span v-if="(!item['月薪范围'][0] && !item['月薪范围'][1]) ||item['月薪范围'][0] === '面议' ||item['月薪范围'] === '面议'">面议</span>
                        <span v-else>{{ item['月薪范围'][0] / 1000}}{{ item['月薪范围'][1] ? '-' + item['月薪范围'][1] / 1000 : '' }}k/月</span>
                      </div>
                    </div>
                    <div class="job-row">
                      <div class="job-side-text">
                        <span v-if="item['城市'] && item['城市'].length > 0">
                          <span
                            v-for="(city, cityidx) in item['城市']"
                            :key="cityidx"
                          >{{ city }}{{ cityidx === item['城市'].length - 1 ? '' : '、' }}</span>
                        </span>
                        <span v-else> 全国 </span>
                      </div>
                      <div class="split"></div>
                      <div class="job-side-text">
                        <span v-if="item['工作经验'] && item['工作经验'][0] && item['工作经验'][1]">{{ item['工作经验'][0] }}-{{ item['工作经验'][1] }}年工作经验</span>
                        <span v-else-if="item['工作经验'] && item['工作经验'][0]">{{ item['工作经验'][0] }}年以上工作经验</span>
                        <span v-else>工作经验不限</span>
                      </div>
                      <div class="split"></div>
                      <div class="job-side-text">{{ item['学历要求'] || '本科' }}</div>
                    </div>
                    <div class="job-row mb0 jcsb">
                      <div
                        class="salary"
                        style="color: #3f3f3f"
                        v-if="item['hunterId']"
                      >{{ item['公司'] }}</div>
                      <div
                        class="salary"
                        style="color: #3f3f3f"
                        v-else-if="item['简称']"
                      >{{ item['简称'] }}</div>
                      <div
                        class="salary"
                        style="color: #3f3f3f"
                        v-else-if="item['公司名称']"
                      >
                        {{ item['公司名称'][0] + item['公司名称'][1] + item['公司名称'][2] + item['公司名称'][3] }}
                      </div>
                      <div
                        class="salary"
                        style="color: #3f3f3f"
                        v-else-if="item['公司']"
                      >
                        {{ item['公司'][0] + item['公司'][1] + item['公司'][2] + item['公司'][3] }}
                      </div>
                      <div class="job-side-text">{{ item['发布时间'] }}</div>
                    </div>
                  </div>
                </div>
                <div class="buttom-button-wrap">
                  <div class="buttom-button-share">
                    <img
                      src="./gary-share.png"
                      alt=""
                    />
                    <span>分享</span>
                  </div>
                  <div class="buttom-button-left">联系TA</div>
                  <div class="buttom-button-right">查看更多热招岗位</div>
                </div>
              </div>
            </div>
            <!-- <div class="input-item">
              <div class="input-label"><b>*</b>姓名</div>
              <div class="input-wrap">
                <el-input
                  size="small"
                  v-model="name"
                ></el-input>
              </div>
              <div class="input-tips">输入您对外展示的姓名，如：Belle 王村花</div>
            </div>
            <div class="input-item">
              <div class="input-label"><b>*</b>职位</div>
              <div class="input-wrap">
                <el-input
                  size="small"
                  v-model="level"
                ></el-input>
              </div>
              <div class="input-tips">可根据您实际的业务需求进行填写，如：高级猎头顾问</div>
            </div>
            <div class="input-item">
              <div class="input-label">公司</div>
              <div class="input-wrap">
                <el-input
                  size="small"
                  v-model="company"
                ></el-input><span>展示</span>
                <el-switch v-model="showCompany"></el-switch>
              </div>
              <div class="input-tips">可根据您实际的业务需求进行填写公司的全称或简称</div>
            </div>
            <div class="input-item">
              <div class="input-label">地址</div>
              <div class="input-wrap">
                <el-input
                  size="small"
                  v-model="address"
                ></el-input>
              </div>
              <div class="input-tips">可填写公司的地址，如：北京、北京朝阳区等</div>
            </div>
            <div class="input-item">
              <div class="input-label">擅长方向,业务线</div>
              <div class="input-wrap">
                <el-input
                  size="small"
                  v-model="goodat"
                ></el-input>
              </div>
              <div class="input-tips">占位符号,上线之前更换</div>
            </div>
            <div class="input-item">
              <div class="input-label"><b>*</b>手机</div>
              <div class="input-wrap">
                <el-input
                  size="small"
                  v-model="tel"
                ></el-input>
              </div>
              <div class="input-tips">填写您的常用手机号</div>
            </div>
            <div class="input-item">
              <div class="input-label"><b>*</b>微信号</div>
              <div class="input-wrap">
                <el-input
                  size="small"
                  v-model="weixin"
                ></el-input>
              </div>
              <div class="input-tips">填写您的微信号</div>
            </div>
            <div class="input-item">
              <div class="input-label">邮箱</div>
              <div class="input-wrap">
                <el-input
                  size="small"
                  v-model="email"
                ></el-input>
              </div>
              <div class="input-tips">可填写您的邮箱</div>
            </div>
            <div class="input-item">
              <div class="input-label">从业年限</div>
              <div class="input-wrap">
                <el-input
                  size="small"
                  v-model="career"
                ></el-input>
              </div>
              <div class="input-tips">可填写您的从业年限以供展示</div>
            </div>
            <div class="input-item">
              <div class="input-label">服务人数</div>
              <div class="input-wrap">
                <el-input
                  size="small"
                  v-model="service"
                ></el-input>
              </div>
              <div class="input-tips">可填写您的服务人数以供展示</div>
            </div>
            <div class="input-item">
              <div class="input-label">推荐岗位数</div>
              <div class="input-wrap">
                <el-input
                  size="small"
                  v-model="recommendation"
                ></el-input>
              </div>
              <div class="input-tips">可填写您的推荐岗位数以供展示</div>
            </div>
            <div class="input-item-textarea">
              <div
                class="input-label"
                style="margin-bottom:15px"
              ><b>*</b>个人介绍</div>
              <div class="input-wrap">
                <el-input
                  size="small"
                  type="textarea"
                  v-model="desc"
                  placeholder="可填写关于您或者公司的介绍。例如：专注于投行、DCM领域的猎头"
                  style="margin-bottom:15px"
                ></el-input>
              </div>
            </div> -->
          </div>
        </div>
        <el-row
          class="bind-next-step"
          type="flex"
          justify="center"
        >
          <el-button
            type="primary"
            size="small"
            @click="save(true)"
            v-if="showSave"
          >保存</el-button>
          <el-button
            type="primary"
            size="small"
            @click="next"
            v-else
          >下一步</el-button>
          <el-button
            type="primary"
            size="small"
            @click="showQrcode"
            v-if="showSave"
          >扫一扫</el-button>
          <el-button
            type="primary"
            size="small"
            @click="showCard"
            v-if="showSave"
          >生成我的名片</el-button>

        </el-row>
      </div>
    </div>
    <el-dialog
      :visible.sync='exampleVisible'
      :append-to-body='true'
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal="false"
      custom-class="custom-dialog"
    >
      <div
        slot="title"
        class="title"
      >
        <div class="title-name">{{ exampleTitle }}</div>
        <div class="side-title"></div>
        <div class="handle-btn">
        </div>
      </div>
      <div v-if="exampleTitle==='个人优势'">
        <div class="example-title">可选择以下模板，再自行修改</div>
        <div
          class="example-wrap"
          v-for="(item,idx) in advExample"
        >
          <span class="adv-idx">{{idx+1}}</span>
          <div class="adv-wrap">
            <div class="adv">
              <img
                src="./icon1.png"
                alt=""
              >
              <span>{{item[0]}}</span>
            </div>
            <div class="adv">
              <img
                src="./icon2.png"
                alt=""
              >
              <span>{{item[1]}}</span>
            </div>
            <div class="adv">
              <img
                src="./icon3.png"
                alt=""
              >
              <span>{{item[2]}}</span>
            </div>
          </div>
          <el-button
            class="adv-button"
            type="primary"
            size="small"
            @click="chooseAdv(item)"
          >应用此模板</el-button>
        </div>
      </div>
      <div v-if="exampleTitle==='个人介绍'">
        <div class="example-title">可选择以下模板，再自行修改</div>
        <div
          class="example-wrap"
          v-for="(item,idx) in descExample"
        >
          <span class="adv-idx">{{idx+1}}</span>
          <p>{{item}}</p>
          <el-button
            type="primary"
            size="small"
            class="adv-button"
            @click="chooseDesc(item)"
          >应用此模板</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync='qrcodeVisible'
      :append-to-body='true'
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal="false"
      custom-class="custom-dialog"
    >
      <div
        slot="title"
        class="title"
      >
        <div class="title-name">扫码查看个人主页</div>
        <div class="side-title"></div>
        <div class="handle-btn">
        </div>
      </div>
      <p style="font-size:18px;text-align:center">扫一扫即可查看个人主页小程序，收藏后可快速分享给候选人</p>
      <img
        style="display:block;margin:20px auto;width:200px"
        :src="MpCode"
        alt=""
      >
      <el-row
        type="flex"
        justify="center"
      >
        <el-button
          type="primary"
          size="small"
          @click="qrcodeVisible=false"
        >确定</el-button>
      </el-row>
    </el-dialog>
    <el-dialog
      :visible.sync='cardVisible'
      :append-to-body='true'
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal="false"
      top="0"
      custom-class="custom-dialog"
    >
      <div
        slot="title"
        class="title"
      >
        <div class="title-name">我的名片</div>
        <div class="side-title"></div>
        <div class="handle-btn">
        </div>
      </div>
      <p style="font-size:18px;text-align:center;margin-bottom:20px">沿着虚线截图，即可发送给候选人</p>
      <div class="card-wrap">
        <div class="card-header">
          <div class="card-avatar">
            <img
              :src="avatar"
              alt=""
            >
          </div>
          <div class="card-name">{{name}}<span>高级猎头顾问</span></div>
          <div class="card-info">
            <div class="card-tel">
              <img
                src="./card/tel.png"
                alt=""
              >
              <span>{{tel}}</span>
            </div>
            <div class="card-address">
              <img
                src="./card/tie.png"
                alt=""
              >
              <span>{{ address }}</span>
            </div>
          </div>
          <div class="card-goodat">
            <span
              v-for="(item,idx) in goodat"
              :key="idx"
            >{{item&&idx!==0?'｜':''}}{{item}}</span>
          </div>
        </div>
        <div class="card-advantage">
          <div class="card-advantage-item">
            <img
              src="./card/icon1.png"
              alt=""
            >
            {{advantage[0]}}
          </div>
          <div class="card-line"></div>
          <div class="card-advantage-item">
            <img
              src="./card/icon2.png"
              alt=""
            >
            {{advantage[1]}}
          </div>
          <div class="card-line"></div>
          <div class="card-advantage-item">
            <img
              src="./card/icon3.png"
              alt=""
            >
            {{advantage[2]}}
          </div>
        </div>
        <div class="card-desc">{{desc}}</div>
        <div class="card-code">
          <img
            :src="MpCode"
            alt=""
          >
          <div class="card-finger">
            <img
              src="./card/finger.png"
              alt=""
            >
            <p>长按识别二维码</p>
            <p style="color:#D7BB91">查看更多职位</p>
          </div>
        </div>
      </div>
      </div>
      <el-row
        type="flex"
        justify="center"
      >
        <el-button
          type="primary"
          size="small"
          @click="cardVisible=false"
        >确定</el-button>
      </el-row>
    </el-dialog>
  </el-dialog>
</template>
<script>
  import QRCode from 'qrcode'
  import { BaseUrl } from '../weimingpian.js'
  const hunterInfoList = [
    {
      hunterId: 'qinchao',
      address: '北京',
      goodat: ['投行股债', 'ABS', 'PEVC'],
      advantage: ['管理50+职位', '成功入职50+人', '服务头部券商'],
      desc:
        '·曾操作多个证券CEO、券商分管投行高管等职位，带领团队覆盖投行股债、ABS、REITs、PEVC等各领域热门业务；\n·客户和候选人认可度极高。包括三中一华、某特色精品投行、知名合资外资券商在内，80%头部机构达成战略合作。',
    },
    {
      hunterId: 'Aki',
      address: '北京',
      goodat: ['投行股债', 'ABS', 'PEVC'],
      advantage: ['管理50+职位', '成功入职50+人', '服务头部券商'],
      desc:
        '·曾操作多个证券CEO、券商分管投行高管等职位，带领团队覆盖投行股债、ABS、REITs、PEVC等各领域热门业务；\n·客户和候选人认可度极高。包括三中一华、某特色精品投行、知名合资外资券商在内，80%头部机构达成战略合作。',
    },
    {
      hunterId: 'Roy',
      address: '北京',
      goodat: ['投行IBD', '投行股债', '一级市场'],
      advantage: ['运作30+职位', '成功推荐100+人', '服务头部基金'],
      desc:
        '·创造并保持业内最快成为百万顾问的记录，带领团队深耕投行IBD、PE等领域。\n·曾为某前5券商成功招募2位债券二级部门总，为某特色精品投行招募4位股权二级部门总和财富管理高层，参与某合资券商核心团队搭建工作。',
    },
    {
      hunterId: 'Luke',
      address: '北京',
      goodat: ['投行IBD', 'PEVC', '投行股债'],
      advantage: ['运作30+职位', '成功推荐101+人', '服务头部基金'],
      desc:
        '·百万顾问，专注投行股和PE领域，曾任职于某Top5券商投行。\n·客户和候选人认可度极高。长期服务三中一华、知名合资外资券商、头部PE和大型国资投资机构等。曾成功操作某A股合资投行MD岗、某港股合资投行MD岗等。',
    },
    {
      hunterId: 'Ada',
      address: '北京',
      goodat: ['投行债', 'ABS', 'REITs'],
      advantage: ['运作30+职位', '成功推荐102+人', '服务头部基金'],
      desc:
        '·百万顾问。深耕一级市场，专注投行债和ABS领域；\n·客户和候选人认可度极高。长期服务客户包括三中一华、知名合资外资券商等。曾为某头部券商和某合资券商成功招募投行债、股方向多位核心层人员。',
    },
    {
      hunterId: 'Ellen',
      address: '北京',
      goodat: ['投行债', 'REITs', 'ABS'],
      advantage: ['运作30+职位', '成功推荐103+人', '服务头部基金'],
      desc:
        '·长期专注投行债、REITs和ABS等热门业务领域；\n·深受候选人信任，客户认可度极高。长期服务头部券商、知名合资外资机构等。曾多次成功为某头部券商、头部基金和私募基金招募REITs相关人才。',
    },
    {
      hunterId: 'Nicole',
      address: '北京',
      goodat: ['投行IBD', '投行股债', '一级市场'],
      advantage: ['运作30+职位', '成功推荐104+人', '服务头部基金'],
      desc:
        '·深耕投行IBD领域，尤其擅长承揽承做和中后台资深层级招聘；\n·深受候选人信任，客户认可度极高。长期服务包括三中一华、知名合资外资券商在内多家券商。曾成功为多家头部券商招募资深承揽人选、股权质控内核核心层。',
    },
    {
      hunterId: 'Elle',
      address: '北京',
      goodat: ['投行IBD', '投行股债', 'pevc'],
      advantage: ['运作30+职位', '成功推荐105+人', '服务头部基金'],
      desc:
        '·专注投行IBD领域，尤其擅长前台承揽承做和资深层级招聘；\n·深受候选人信任，客户认可度极高。长期服务客户包括三中一华、知名合资外资券商、精品投行等。曾成功为某头部券商招募明星执行层。',
    },
    {
      hunterId: 'Tara',
      address: '北京',
      goodat: ['投行IBD', '投行股债', 'PEVC'],
      advantage: ['运作30+职位', '成功推荐106+人', '服务头部基金'],
      desc:
        '·专注投行IBD领域，尤其擅长承揽承做和中后台核心层级招聘；\n·深受候选人信任，客户认可度极高。长期服务客户包括三中一华、知名合资外资券商、新经济领域精品投行等。',
    },
    {
      hunterId: 'Shirley',
      address: '北京',
      goodat: ['PEVC领域', '创投', '互联网'],
      advantage: ['运作30+职位', '成功推荐107+人', '服务头部基金'],
      desc:
        '·专注PEVC领域，尤其擅长消费、科技等行业。\n·深受候选人信任，客户认可度极高。长期服务客户包括多家头部PE机构、顶级VC等，曾成功为某知名双币种头部基金招募消费ED。',
    },
    {
      hunterId: 'Jessica',
      address: '北京',
      goodat: ['PEVC领域', '金融科技', '互联网'],
      advantage: ['运作30+职位', '成功推荐108+人', '服务头部基金'],
      desc:
        '·专注PEVC领域的资深顾问。从业6年，是曾任公司“最年轻的Top Biller”。\n·成功服务的客户有阿里巴巴集团，市场化美元PE和VC等，成功操作某一线PE投资MD岗，亚洲最大工业物流集团投资岗等。',
    },
    {
      hunterId: 'Crystal',
      address: '北京',
      goodat: ['PEVC领域', '互联网', '金融科技'],
      advantage: ['运作30+职位', '成功推荐109+人', '服务头部基金'],
      desc:
        '·专注PEVC领域，尤其擅长医疗、科技和消费行业。\n·长期服务客户包括多家头部PE机构、顶级VC等，入职3个月内为某知名美元PE成功招募医疗投资VP，为某一线人民币PE成功招募科技行业投资总监等。',
    },
    {
      hunterId: 'Frank',
      address: '北京',
      goodat: ['PEVC领域', '互联网', '咨询'],
      advantage: ['运作30+职位', '成功推荐110+人', '服务头部基金'],
      desc: '·专注PEVC领域，尤其擅长消费、科技和医疗行业。\n·长期服务客户包括多家头部PE机构、顶级VC基金等。',
    },
    {
      hunterId: 'Tina',
      address: '北京',
      goodat: ['PEVC领域', '互联网', '咨询'],
      advantage: ['运作30+职位', '成功推荐112+人', '服务头部基金'],
      desc: '·专注PEVC领域，深耕金融科技、科技和医疗行业。\n·长期服务客户包括多家头部PE机构、顶级VC基金等。',
    },
    {
      hunterId: 'Eric',
      address: '北京',
      goodat: ['PEVC领域', '互联网', '咨询'],
      advantage: ['运作30+职位', '成功推荐113+人', '服务头部基金'],
      desc: '·专注PEVC领域，深耕科技、医疗等行业。\n·长期服务客户包括多家头部PE机构、顶级VC基金等。',
    },
    {
      hunterId: 'Cathy',
      address: '北京',
      goodat: ['二级市场', '泛资管领域'],
      advantage: ['运作30+职位', '成功推荐114+人', '服务头部基金'],
      desc:
        '·12年金融猎头经验，曾经合作过国内80%公募基金公司，创造了金融猎头行业的最高业绩。\n·具有敏锐的金融市场触觉和业务发展前瞻力，与业内多位知名高管保持长期密切合作。',
    },
    {
      hunterId: 'Morris',
      address: '上海',
      goodat: ['二级投资和研究', '股权投资'],
      advantage: ['运作30+职位', '成功推荐115+人', '服务头部基金'],
      desc:
        '·资深顾问，长期专注二级投研板块和股权投资领域，尤其擅长硬科技半导体行业；\n·长期服务多家头部公募和特色化券商。曾为某特色合资券商成功招募运维负责人，为某头部PE机构招募半导体投资核心层等。',
    },
    {
      hunterId: 'Wendy',
      address: '上海',
      goodat: ['二级投资和研究', '股权投资'],
      advantage: ['运作30+职位', '成功推荐116+人', '服务头部基金'],
      desc:
        '·资深顾问，长期专注二级投研板块和股权投资领域；\n·长期服务多家头部公募和特色化券商，尤其擅长公募/券商高管职位。曾为某头部公募基金成功招募固收首席投资官（公司级），为某知名券商直投基金成功招募二级部门总。',
    },
    {
      hunterId: 'Alinda',
      address: '北京',
      goodat: ['二级投资', '研究'],
      advantage: ['运作30+职位', '成功推荐117+人', '服务头部基金'],
      desc:
        '·资深顾问，长期专注二级投资领域；\n·长期服务多家头部公募和特色化券商，尤其擅长公募/券商IT高管职位。曾为多家客户成功招募多位优秀基金经理。',
    },
    {
      hunterId: 'Daniel',
      address: '北京',
      goodat: ['人力资源', 'pevc', '咨询'],
      advantage: ['运作30+职位', '成功推荐118+人', '服务头部基金'],
      desc:
        '·资深顾问，长期专注人力资源和股权投资领域；\n·长期服务多家头部基金和顶级投资机构，尤其擅长人力资源职位。曾为多家客户成功招募多位HR核心层。',
    },
    {
      hunterId: 'Emma',
      address: '北京',
      goodat: ['二级投资', '金融科技', '量化投资'],
      advantage: ['运作30+职位', '成功推荐119+人', '服务头部基金'],
      desc:
        '·资深顾问，专注二级投资和金融科技板块；\n·长期服务多家头部公募和特色化券商，擅长公募/券商IT高管职位。曾为两家前十公募推荐量化投资总监岗、某快速成长期公募FOF负责人，为多家客户推荐多位优秀基金经理。',
    },
    {
      hunterId: 'NateYu',
      address: '北京',
      goodat: ['二级投资', '金融科技', '量化投资'],
      advantage: ['运作30+职位', '成功推荐119+人', '服务头部基金'],
      desc:
        '·资深顾问，专注二级投资和金融科技板块；\n·长期服务多家头部公募和特色化券商，擅长公募/券商IT高管职位。曾为两家前十公募推荐量化投资总监岗、某快速成长期公募FOF负责人，为多家客户推荐多位优秀基金经理。',
    },
    {
      hunterId: 'chenshen',
      address: '北京',
      goodat: ['二级投资', '金融科技', '量化投资'],
      advantage: ['运作30+职位', '成功推荐119+人', '服务头部基金'],
      desc:
        '·资深顾问，专注二级投资和金融科技板块；\n·长期服务多家头部公募和特色化券商，擅长公募/券商IT高管职位。曾为两家前十公募推荐量化投资总监岗、某快速成长期公募FOF负责人，为多家客户推荐多位优秀基金经理。',
    },
    {
      hunterId: 'jaxonzheng',
      address: '北京',
      goodat: ['二级投资', '金融科技', '量化投资'],
      advantage: ['运作30+职位', '成功推荐119+人', '服务头部基金'],
      desc:
        '·资深顾问，专注二级投资和金融科技板块；\n·长期服务多家头部公募和特色化券商，擅长公募/券商IT高管职位。曾为两家前十公募推荐量化投资总监岗、某快速成长期公募FOF负责人，为多家客户推荐多位优秀基金经理。',
    },
    {
      hunterId: 'xuedong',
      address: '北京',
      goodat: ['二级投资', '金融科技', '量化投资'],
      advantage: ['运作30+职位', '成功推荐119+人', '服务头部基金'],
      desc:
        '·资深顾问，专注二级投资和金融科技板块；\n·长期服务多家头部公募和特色化券商，擅长公募/券商IT高管职位。曾为两家前十公募推荐量化投资总监岗、某快速成长期公募FOF负责人，为多家客户推荐多位优秀基金经理。',
    },
    {
      hunterId: 'Joy',
      address: '北京',
      goodat: ['机构销售', '固收投资', '量化投资'],
      advantage: ['运作30+职位', '成功推荐120+人', '服务头部基金'],
      desc:
        '·深耕机构销售和固收投资领域，尤其擅长研究所机构销售、资管机构销售和债券投资；\n·深受候选人信任，客户认可度极高。长期服务多家头部公募和特色化券商，曾成功为某知名合资券商招募机构销售核心层。',
    },
    {
      hunterId: 'Tina',
      address: '长沙',
      goodat: ['风控', '法务合规', '研究'],
      advantage: ['从业10+年', '服务300+人', '服务多家名企'],
      desc:
        '·专注合规风控、财务、研究等领域，14年人力资源工作经验，曾于某top15上市券商担任HRBP；\n·曾牵头某大型券商研究所、新三板、融资融券、资管分公司的业务搭建及高招工作，并成功为某知名合资券商招募财务负责人。',
    },
    {
      hunterId: 'Shally',
      address: '广州',
      goodat: ['机构销售', '权益投资', '产品'],
      advantage: ['运作30+职位', '成功推荐100+人', '服务头部基金'],
      desc:
        '·深耕机构销售、权益投资、产品领域4年有余。服务多家头部基金、中大型基金和头部券商资管； \n·多次成功操作券商及公募机构业务负责人、权益负责人等职位，成功交付多个金融机构的投研团队、市场销售团队搭建项目。',
    },
    {
      hunterId: 'Ray',
      address: '广州',
      goodat: ['机构销售', '权益投资', '产品'],
      advantage: ['运作30+职位', '成功推荐101+人', '服务头部基金'],
      desc:
        '·深耕机构销售、权益投资、产品领域近4年。服务多家头部基金、中大型基金和头部券商资管； \n·深受客户和候选人信赖，曾为某大型公募基金机构成功招募销售负责人、为某大型券商资管招募权益投资总监等。',
    },
    {
      hunterId: 'Linkpan',
      address: '北京',
      goodat: ['二级中后台', '风险', '研究'],
      advantage: ['服务300+人', '服务多家名企', '擅长人岗匹配'],
      desc:
        '·专注二级市场中后台领域，尤其擅长风险版块和研究版块人才寻访和招聘； \n·深受候选人信任，客户认可度极高。长期服务客户包括三中一华、知名合资外资券商、精品投行等。',
    },
    {
      hunterId: 'bcshen',
      address: '北京',
      goodat: ['投行IBD', '投行债', '质控内核'],
      advantage: ['服务300+人', '服务多家名企', '擅长人岗匹配'],
      desc:
        '·专注投行IBD领域，尤其擅长前台承揽承做和资深层级招聘； \n·深受候选人信任，客户认可度极高。长期服务客户包括三中一华、知名合资外资券商、精品投行等',
    },
  ]
  export default {
    props: [],
    watch: {
      phoneIsWechat(val) {
        if (val) {
          this.weixin = this.tel
        }
      },
    },
    data() {
      return {
        ifBind: true,
        dialogVisible: false,
        hunterId: app.user.account,
        defaultAvatars: [
          'https://alphahr-files-backup.oss-cn-beijing.aliyuncs.com/wechat/jobHunting/4.0/hunterBg0.png',
          'https://alphahr-files-backup.oss-cn-beijing.aliyuncs.com/wechat/jobHunting/4.0/hunterBg1.png',
          'https://alphahr-files-backup.oss-cn-beijing.aliyuncs.com/wechat/jobHunting/4.0/hunterBg2.png',
          'https://alphahr-files-backup.oss-cn-beijing.aliyuncs.com/wechat/jobHunting/4.0/hunterBg3.png',
          'https://alphahr-files-backup.oss-cn-beijing.aliyuncs.com/wechat/jobHunting/4.0/hunterBg4.png',
          'https://alphahr-files-backup.oss-cn-beijing.aliyuncs.com/wechat/jobHunting/4.0/hunterBg5.png',
        ],
        QRcode: '',
        dialogType: '',
        phoneIsWechat: false,
        ifSelfPhoto: true,
        avatar:
          'https://alphahr-files-backup.oss-cn-beijing.aliyuncs.com/wechat/jobHunting/hunterAvatar/' +
          app.user.account +
          '.png',
        MpCode: '',
        name: '',
        tel: '',
        weixin: '',
        level: '',
        company: '',
        address: '',
        email: '',
        career: '',
        service: '',
        recommendation: '',
        desc: '',
        goodat: ['', '', ''],
        advantage: ['', '', ''],
        bindStep: 1,
        advExample: [
          ['从业10+年', '服务300+人', '服务多家名企'],
          ['运作30+职位', '成功推荐100+人', '服务头部基金'],
          ['管理50+职位', '成功入职50+人', '服务头部券商'],
        ],
        descExample: [
          '·创造并保持业内最快成为百万顾问的记录，带领团队深耕投行IBD、PE等领域。\n·曾为某前5券商成功招募2位债券二级部门总，为某特色精品投行招募4位股权二级部门总和财富管理高层，参与某合资券商核心团队搭建工作。',
          '·专注PEVC领域，尤其擅长医疗、科技和消费行业。\n·长期服务客户包括多家头部PE机构、顶级VC等，入职3个月内为某知名美元PE成功招募医疗投资VP，为某一线人民币PE成功招募科技行业投资总监等。',
          '·资深顾问，长期专注人力资源和股权投资领域。\n·长期服务多家头部基金和顶级投资机构，尤其擅长人力资源职位。曾为多家客户成功招募多位HR核心层。',
        ],
        showSave: false,
        showCompany: false,
        exampleTitle: '',
        exampleVisible: false,
        qrcodeVisible: false,
        cardVisible: false,
        bindVisible: false,
        jobs: [
          {
            _id: 'fe-NpwWuWPU',
            标题: '财务总监/高级经理',
            城市: ['上海'],
            公司: '大集团旗下全资子公司',
            一句话简介: '大集团旗下全资子公司',
            职位亮点: ['股东实力强', '大平台', '文化好', '人员整体素质高', '稳定'],
            圆手行业: '私募股权（PEVC）',
            圆手职能: [],
            新圆手细分职能: ['投行业务'],
            学历要求: '本科',
            月薪范围: '面议',
            职位描述:
              '岗位职责:\n\n岗位要求:\n下面带2人；现在这个同事要离职；\n年龄 控制 31-40岁，40-50个legal\n最好有甲方经验；实操要求比较高；国企背景的更适合自己； 不要一直外资路子；\n团队比较年轻；\n项目的亮点与优势:\n\n项目的亮点与优势:\n',
            项目的亮点与优势: '项目的亮点与优势:\n',
            工作经验: [3, 5],
            月数: 12,
            官网: '',
            coreProjectId: 'HJld9i_VDL',
            平台等级: 'A',
            公司亮点: {
              content: '不懂上汽必看文章(可以发给人选): https://mp.weixin.qq.com/s/LpEcg8WdPaN82i7pju5N_g',
              keywords: {
                股东实力强: true,
                大平台: true,
                固薪高: false,
                激励机制好: false,
                文化好: true,
                人员整体素质高: true,
                压力小: false,
                稳定: true,
              },
            },
            公司性质: '国有企业',
            简称: '上汽投资',
            职位吸引点: '大集团旗下全资子公司',
            职位性质: '全职',
            hunterId: 'jaxonzheng',
            状态: '已下线',
            微名片状态: '已上线',
            createdAt: 1608626134638,
            updatedAt: 1608626134638,
          },
          {
            _id: '-fyB9j-SzUj',
            标题: '财务总监/高级经理',
            城市: ['上海'],
            公司: '大集团旗下全资子公司',
            一句话简介: '大集团旗下全资子公司',
            职位亮点: ['股东实力强', '大平台', '文化好', '人员整体素质高', '稳定'],
            圆手行业: '私募股权（PEVC）',
            圆手职能: [],
            新圆手细分职能: ['投行业务'],
            学历要求: '本科',
            月薪范围: '面议',
            职位描述:
              '岗位职责:\n\n岗位要求:\n下面带2人；现在这个同事要离职；\n年龄 控制 31-40岁，40-50个legal\n最好有甲方经验；实操要求比较高；国企背景的更适合自己； 不要一直外资路子；\n团队比较年轻；\n项目的亮点与优势:\n',
            项目的亮点与优势: '项目的亮点与优势:\n',
            工作经验: [3, 5],
            月数: 12,
            官网: '',
            coreProjectId: 'HJld9i_VDL',
            平台等级: 'A',
            公司亮点: {
              content: '不懂上汽必看文章(可以发给人选): https://mp.weixin.qq.com/s/LpEcg8WdPaN82i7pju5N_g',
              keywords: {
                股东实力强: true,
                大平台: true,
                固薪高: false,
                激励机制好: false,
                文化好: true,
                人员整体素质高: true,
                压力小: false,
                稳定: true,
              },
            },
            公司性质: '国有企业',
            简称: '上汽投资',
            职位吸引点: '大集团旗下全资子公司',
            职位性质: '全职',
            hunterId: 'jaxonzheng',
            状态: '已下线',
            微名片状态: '已上线',
            createdAt: 1608626114399,
            updatedAt: 1608626114399,
          },
        ],
        validate: [
          {
            key: 'name',
            name: '姓名',
          },
          {
            key: 'tel',
            name: '手机',
          },
          {
            key: 'goodat',
            name: '擅长领域',
          },
          {
            key: 'address',
            name: '地址',
          },
          {
            key: 'desc',
            name: '介绍',
          },
        ],
      }
    },
    methods: {
      ifSelfPhotoChange(ifSelfPhoto) {
        if (ifSelfPhoto) {
          this.avatar =
            'https://alphahr-files-backup.oss-cn-beijing.aliyuncs.com/wechat/jobHunting/hunterAvatar/' +
            app.user.account +
            '.png'
        } else {
          this.avatar = this.defaultAvatars[0]
        }
      },
      close() {
        this.dialogType = ''
        this.dialogVisible = false
      },
      chooseAdv(item) {
        this.advantage = JSON.parse(JSON.stringify(item))
        this.exampleVisible = false
      },
      chooseDesc(item) {
        this.desc = item
        this.exampleVisible = false
      },
      async open(dialogType) {
        this.dialogType = dialogType
        this.dialogVisible = true
        if (dialogType === '用户绑定') {
          this.generateQRcode()
          this.ifBind = false
          this.bindStep = 1
          let interval = setInterval(async () => {
            const { result } = await app.service('wechat').getUser({ account: app.user.account })
            if (result.开放平台 && result.开放平台.微元科技) {
              this.bindVisible = true
              app.user = result
              clearInterval(interval)
            }
          }, 700)
        } else if (dialogType === '个人信息完善') {
          await this.getHunterInfo()
          this.ifBind = true
          this.bindStep = 3
          this.showSave = true
        } else if (dialogType === '小程序二维码') {
          this.generatePersonQRcode()
        }
      },
      async toEditInfo() {
        this.dialogType = '个人信息完善'
        this.bindVisible = false
        this.bindStep = 3
        this.showSave = true
        await this.getHunterInfo()
        this.$emit('changeBind', true)
      },
      async generatePersonQRcode() {
        const { data } = await this.$axios.get(
          `https://www.yuanshouhr.com/api/salaryNew/getMpCode?appid=wx4d717856feced5bf&scene=${app.user.account}&path=pages/myJobList/main`,
        )
        this.MpCode = data.data.code
      },
      generateQRcode() {
        const name = app.user.姓名 || ''
        const account = app.user.account || ''
        const tel = app.user.工作手机 || ''
        const url = `https://www.yuanshouhr.com/#/wxsalarybind?name=${name}&account=${account}&tel=${tel}`
        QRCode.toDataURL(url).then((imgData) => {
          if (imgData) {
            this.QRcode = imgData
          }
        })
      },
      async next() {
        this.bindStep++
        if (this.bindStep === 3) {
          const { data } = await app.service('company').refreshUser(app.user.account)
          if (!data || !data.开放平台 || !data.开放平台.微元科技) {
            this.$message(`您还未绑定完成,请重新绑定后重试`)
            this.bindStep = 1
            return
          }
          app.user = data
          this.dialogType = '个人信息完善'
          this.showSave = true
        }
      },
      openExample(type) {
        this.exampleTitle = type
        this.exampleVisible = true
      },
      async showQrcode() {
        if (!this.MpCode) {
          await this.generatePersonQRcode()
        }
        this.qrcodeVisible = true
      },
      async showCard() {
        if (!this.MpCode) {
          await this.generatePersonQRcode()
        }
        this.cardVisible = true
      },
      async save(sendMessage) {
        for (let ele of this.validate) {
          if (!this[ele.key] || this[ele.key].length === 0) {
            this.$message(`请填写${ele.name}`)
            return
          }
        }
        const hunterInfo = {
          avatar: this.avatar,
          name: this.name,
          tel: this.tel,
          weixin: this.phoneIsWechat ? this.tel : this.weixin,
          goodat: this.goodat,
          advantage: this.advantage,
          address: this.address,
          desc: this.desc,
        }
        const { data } = await app.service('wechat').externalApi({
          baseUrl: BaseUrl,
          path: '/api/users/upsertUser',
          method: 'POST',
          externalData: {
            userData: JSON.stringify({
              unionid: app.user.开放平台.微元科技.unionid,
              hunterInfo,
              hunterId: app.user.account,
            }),
          },
        })
        if (sendMessage) {
          await app.service('wechat').externalApi({
            baseUrl: BaseUrl,
            path: '/api/users/newSendMessage',
            method: 'POST',
            externalData: {
              openid: app.user.开放平台.微元科技.openid,
              hunterId: app.user.account,
              name: this.name,
            },
          })
        }
        this.dialogVisible = false
        this.ifBind = true
        this.$message('保存成功')
      },
      async getHunterInfo() {
        const { data } = await app.service('wechat').externalApi({
          baseUrl: BaseUrl,
          path: '/api/users/findUserByUnionid/' + app.user.开放平台.微元科技.unionid,
          method: 'GET',
        })
        const defaultHunterInfo = hunterInfoList.find((h) => h.hunterId === app.user.account) || {}
        if (data.hunterInfo) {
          if (data.hunterInfo.avatar && data.hunterInfo.avatar.includes('hunterAvatar')) {
            this.ifSelfPhoto = true
          } else {
            this.ifSelfPhoto = false
          }
          this.avatar = data.hunterInfo.avatar
          this.name = data.hunterInfo.name || ''
          this.tel = data.hunterInfo.tel || ''
          this.weixin = data.hunterInfo.weixin || ''
          this.goodat =
            (data.hunterInfo.goodat && data.hunterInfo.goodat.slice(0, 3)) ||
            JSON.parse(JSON.stringify(defaultHunterInfo.goodat || [])) ||
            []
          this.advantage =
            data.hunterInfo.advantage || JSON.parse(JSON.stringify(defaultHunterInfo.advantage || [])) || []
          this.address = data.hunterInfo.address || defaultHunterInfo.address || ''
          this.desc = data.hunterInfo.desc || defaultHunterInfo.desc || ''
        } else if (Object.keys(defaultHunterInfo).length > 0) {
          this.goodat = JSON.parse(JSON.stringify(defaultHunterInfo.goodat || [])) || []
          this.advantage = JSON.parse(JSON.stringify(defaultHunterInfo.advantage || [])) || []
          this.address = defaultHunterInfo.address || ''
          this.desc = defaultHunterInfo.desc || ''
        }
      },
    },
  }
</script>
<style>
.custom-dialog.green-bg {
  background-color: rgb(76, 115, 128);
}
</style>
<style scoped>
.mp-code {
  display: flex;
  align-items: center;
  justify-content: center;
}
.mp-code img {
  width: 200px;
  height: 200px;
}
.bind-main {
  font-size: 16px;
}
.bind-main p {
  margin-bottom: 10px;
}
.bind-fixed {
  border-bottom: 1px solid #f2f2f2;
  margin-bottom: 20px;
}
.bind-main img {
  width: 200px;
  height: 200px;
  display: block;
  margin: 10px auto;
}
.part-title {
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.part-title span {
  margin-left: 10px;
  color: rgb(255, 102, 0);
  font-size: 12px;
}
.muti-input .el-input {
  width: 25%;
  margin-right: 20px;
}
.input-item {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding-left: 10px;
  margin-bottom: 15px;
}
.input-label {
  margin-right: 10px;
  font-size: 14px;
  display: flex;
  align-items: center;
  min-width: 90px;
  font-weight: 600;
}
.input-label b {
  color: #f56c6c;
  margin-right: 2px;
  display: block;
}
.input-wrap {
  flex: 1;
  display: flex;
  align-items: center;
}
.input-wrap > span {
  display: block;
  font-size: 14px;
  flex-shrink: 0;
  margin: 0 5px;
}
.input-tips {
  color: #bbb;
  width: 100%;
  font-size: 12px;
  margin-top: 10px;
  padding-left: 100px;
}
.bind-input {
  display: flex;
}
.left-part {
  flex-grow: 1;
  margin-right: 100px;
}
.right-part {
  width: 375px;
  position: relative;
}
.right-part div {
  box-sizing: border-box;
}
.right-part img {
  width: 100%;
  height: 100%;
  display: block;
}
.right-part .hunter {
  width: 100%;
  height: 375px;
  margin-bottom: 45px;
  position: relative;
}
.right-part .hunter-info-box {
  width: 355px;
  height: 212px;
  border-radius: 5px;
  position: absolute;
  left: 50%;
  margin-left: -177px;
  bottom: -35px;
  overflow: hidden;
}
.right-part .hunter-info {
  width: 355px;
  height: 173px;
  background-color: rgba(0, 0, 0, 0.56);
  padding: 14px 12px;
}
.right-part .hunter-info-name {
  font-size: 21px;
  font-weight: 600;
  color: #ffffff;
  line-height: 30px;
  text-align: center;
}
.right-part .hunter-info-location {
  font-size: 11px;
  font-weight: 400;
  color: #ffffff;
  line-height: 22px;
  margin-bottom: 8px;
  text-align: center;
}
.right-part .hunter-info-desc {
  font-size: 11px;
  font-weight: 400;
  color: #ffffff;
  line-height: 18px;
  white-space: pre-line;
}
.right-part .hunter-info-num {
  width: 100%;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  background-color: #fff;
}
.right-part .hunter-info-num-item {
  display: flex;
  align-items: center;
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #aaaaaa;
}
.right-part .hunter-info-num-item img {
  width: 16px;
  height: 16px;
  margin-right: 5px;
}
.right-part .title {
  font-size: 15px;
  font-weight: 600;
  color: #3f3f3f;
  line-height: 21px;
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  padding-left: 10px;
}
.right-part .title::before {
  content: '';
  display: block;
  align-items: center;
  width: 3px;
  height: 23px;
  background: #cfad78;
  border-radius: 2px;
  margin-right: 8px;
}
.right-part .job-item {
  width: 356px;
  min-height: 120px;
  margin: 0 auto 10px;
  box-sizing: border-box;
  padding: 20px 15px;
  border-radius: 5px;
  background-color: #fff;
}
.right-part .job-row {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}
.right-part .jcsb {
  justify-content: space-between;
}
.right-part .flexw {
  flex-wrap: wrap;
}
.right-part .mb0 {
  margin-bottom: 0;
}
.right-part .job-title,
.right-part .training-title {
  font-size: 14px;
  color: #222;
  font-weight: 600;
}
.right-part .job-title {
  max-width: 60%;
  margin-right: 15px;
}
.right-part .salary {
  font-size: 14px;
  color: rgba(229, 111, 52, 1);
  font-weight: 600;
}
.right-part .job-side-text.dark-text {
  color: #3f3f3f;
}
.right-part .job-side-text {
  font-size: 12px;
  color: #999;
  margin-right: 10px;
}
.right-part .job-tag {
  min-width: 55px;
  height: 22px;
  background: rgba(245, 245, 245, 1);
  border-radius: 2px;
  padding: 0 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: rgba(151, 151, 153, 1);
  margin-right: 4px;
  margin-bottom: 4px;
}
.right-part .split {
  width: 1px;
  height: 12px;
  background: rgba(171, 179, 193, 1);
  margin: 0 10px 0 0;
}
.right-part .buttom-button-wrap {
  width: 375px;
  height: 49px;
  background: #ffffff;
  box-shadow: 0px -1px 2px 0px rgba(221, 221, 221, 0.5);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  position: absolute;
  bottom: 0;
  left: 0;
}
.right-part .buttom-button-share img {
  width: 22px;
  height: 22px;
  margin: 5px 0 2px;
}
.right-part .buttom-button-share span {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #a6aabb;
}
.right-part .buttom-button-share {
  flex-grow: 1;
  flex-shrink: 0;
  background-color: transparent;
  padding: 0;
  line-height: 16px;
  text-align: left;
}
.right-part .buttom-button-left {
  width: 152px;
  height: 40px;
  background: #f2e4cd;
  box-shadow: 0px -1px 2px 0px rgba(221, 221, 221, 0.5);
  border-radius: 4px;
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #cdaa75;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
}
.right-part .buttom-button-right {
  width: 152px;
  height: 40px;
  background: #e3c490;
  box-shadow: 0px -1px 2px 0px rgba(221, 221, 221, 0.5);
  border-radius: 4px;
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.right-part .empty {
  margin: 0 auto 10px;
  width: 356px;
  /* background-color: #fff; */
  height: 75px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}
.right-part .log-btn {
  width: 375vw;
  background-color: transparent;
  position: fixed;
  left: 0;
  top: 0;
  margin: 0;
  padding: 0;
}
.example-title {
  margin-left: 10px;
  color: rgb(255, 102, 0);
  font-size: 14px;
  margin-bottom: 20px;
}
.example-wrap,
.adv-wrap {
  display: flex;
  align-items: center;
}
.example-wrap {
  margin-bottom: 15px;
}
.adv-idx {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #3f3f3f;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  margin-right: 20px;
  flex-shrink: 0;
}
.adv-wrap {
  margin-right: 20px;
}
.adv {
  display: flex;
  align-items: center;
  font-size: 16px;
  width: 140px;
}
.adv img {
  width: 16px;
  height: 16px;
  margin-right: 10px;
}
.adv span {
  font-size: 12px;
  margin-right: 20px;
}
.example-wrap p {
  line-height: 1.8;
  font-size: 12px;
  white-space: pre-line;
  margin: 0 20px;
}
.bind-title {
  width: 431px;
  height: 70px;
  margin: 15px auto;
  font-size: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgb(1, 51, 68);
  background-color: rgba(255, 255, 255, 0.76);
}
.bind-tips div {
  display: flex;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.66);
  line-height: 1.8;
}
.bind-tips {
  padding-bottom: 30px;
  border-bottom: 1px dashed #fff;
  display: flex;
  justify-content: center;
}
.bind-side-title {
  color: #fff;
  font-size: 20px;
  text-align: center;
  margin: 30px 0 20px;
}
.green-bg {
  background-color: rgb(76, 115, 128);
  padding-top: 1px;
  margin: 0 auto;
  padding-bottom: 20px;
}
.bind-button {
  display: block;
  width: 80%;
  margin: 0 auto;
}
.bind-pic {
  width: 375px;
  margin: 20px auto 0;
}
.bind-pic img {
  width: 100%;
  display: block;
}
.card-wrap {
  width: 343px;
  padding: 12px 12px 18px;
  margin: 0 auto 14px;
  border: 2px dashed #808080;
  background-color: #f8fafd;
}
.card-header {
  width: 100%;
  background-image: url('./card/header.png');
  background-size: 100% 105px;
  background-repeat: no-repeat;
  padding-top: 73px;
}
.card-avatar {
  width: 87px;
  height: 87px;
  margin: 0 auto;
  margin-bottom: 10px;
  border-radius: 50%;
  overflow: hidden;
}
.card-avatar img {
  width: 100%;
  height: 100%;
  display: block;
}
.card-name {
  font-size: 14px;
  font-weight: 600;
  color: #343434;
  line-height: 21px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.card-name span {
  margin-left: 4px;
  height: 17px;
  border-radius: 8px;
  border: 1px solid #cdaa75;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  font-size: 12px;
  font-weight: 400;
  color: #cdaa75;
}
.card-info {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2px;
}
.card-tel,
.card-address {
  display: flex;
  align-items: center;
  margin-right: 17px;
}
.card-address {
  margin-right: 0;
}
.card-goodat {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 6px;
}
.card-tel img {
  width: 8px;
  height: 8px;
  display: block;
  margin-right: 2px;
}
.card-tel span,
.card-address span,
.card-goodat span {
  font-size: 12px;
  font-weight: 400;
  color: #8f8f8f;
  line-height: 19px;
}
.card-address {
  display: flex;
  align-items: center;
}
.card-address img {
  width: 4px;
  height: 9px;
  margin-right: 2px;
}
.card-advantage {
  width: 100%;
  height: 54px;
  background: #ffffff;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 13px;
  margin-bottom: 9px;
}
.card-line {
  width: 1px;
  height: 31px;
  background-color: #e8e8e8;
  margin: 0 3px;
}
.card-advantage-item {
  display: flex;
  align-items: center;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #4c5a7c;
  white-space: nowrap;
}
.card-advantage-item img {
  width: 18px;
  height: 18px;
  display: block;
  margin-right: 2px;
}
.card-desc {
  width: 100%;
  padding: 17px 11px;
  font-size: 10px;
  font-weight: 400;
  color: #757575;
  line-height: 20px;
  white-space: pre-line;
  margin-bottom: 7px;
  background: #ffffff;
}
.card-code {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 87px;
  background: #ffffff;
  border-radius: 9px;
}
.card-code > img {
  width: 69px;
  height: 69px;
  display: block;
  margin-right: 77px;
}
.card-finger {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.card-finger img {
  width: 29px;
  height: 29px;
  margin-bottom: 7px;
}
.card-finger p {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #8f8f8f;
  line-height: 15px;
}
</style>
